export default import.meta.ROLLDOWN_FILE_URL_qi8xmSXSbTWjxzeotr3tRA